<template>
  <div>
    <v-card class="pa-3">
      <v-row justify="center">
        <v-col cols="12" md="8" align-self="center">
          <v-row>
            <v-col cols="12" align-self="center" class="pb-0">
              <h3 class="text-left">
                {{ title }}
              </h3>
            </v-col>
            <v-col cols="12" align-self="center">
              <h4 class="text-left font-weight-medium">
                {{ description }}
              </h4>
            </v-col>
          </v-row>
        </v-col>

        <v-spacer></v-spacer>
        
        <v-col cols="12" md="3" align-self="center">
          <a :href="`${url}`" target="_blank">
            <img 
              :src="`https://img.youtube.com/vi/${url.split('=')[1]}/0.jpg`" 
              alt="demo-video-thumbnail" 
              width="150px"
            >
          </a>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SetupVideoDemo',

  components: {},

  props: {
    "title": {
      type: String,
      default: 'Watch a complete setup video!'
    },
    "description": {
      type: String,
      default: 'Learn how to setup an institution on Intract with just a few steps by watching this video'
    },
    "url": {
      type: String,
      default: 'https://www.youtube.com/channel/UCwmMrEkM87OKUO6gGps_r8w/videos'
    }
  },

  computed: {

  },

  data() {
    return {

    }
  },

  methods: {

  },

  created() {

  }
}
</script>

<style>

</style>